import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Mail, MapPin } from "lucide-react";

const Footer = ({ settings }) => {
  const contact = settings?.contact || {};
  const about = settings?.about || {};
  return (
    <footer className="bg-f2b-black text-white pt-20 pb-10" data-testid="public-footer">
      <div className="f2b-container grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="mb-5">
            <img src="/brand/f2b-logo-light.png" alt="FACADES2build" className="h-12 w-auto" />
          </div>
          <p className="f2b-lead text-white/70 max-w-md text-lg leading-relaxed">
            {about.positioning ||
              "Événement professionnel et plateforme éditoriale dédiés aux façades et à l'enveloppe du bâtiment."}
          </p>
          <a
            href={about.buildinglab_url || "https://www.buildinglab.fr"}
            target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 mt-6 text-sm text-f2b-cyan f2b-link-underline"
            data-testid="footer-buildinglab"
          >
            Une initiative BuildingLab →
          </a>
        </div>

        <div>
          <h4 className="f2b-kicker text-f2b-gray mb-5">Navigation</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/edition-2026" className="hover:text-f2b-cyan">Édition 2026</Link></li>
            <li><Link to="/programme" className="hover:text-f2b-cyan">Programme</Link></li>
            <li><Link to="/intervenants" className="hover:text-f2b-cyan">Intervenants</Link></li>
            <li><Link to="/blog" className="hover:text-f2b-cyan">Expertises</Link></li>
            <li><Link to="/partenaires" className="hover:text-f2b-cyan">Partenaires</Link></li>
            <li><Link to="/archives" className="hover:text-f2b-cyan">Archives</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="f2b-kicker text-f2b-gray mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><MapPin size={16} className="text-f2b-cyan mt-0.5" />{contact.address || "Paris"}</li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-f2b-cyan" />
              <a href={`mailto:${contact.email || "contact@facades2build.com"}`} className="hover:text-f2b-cyan">
                {contact.email || "contact@facades2build.com"}
              </a>
            </li>
          </ul>
          <div className="flex gap-3 mt-6">
            {contact.linkedin && (
              <a href={contact.linkedin} target="_blank" rel="noreferrer" className="p-2 border border-white/20 hover:border-f2b-cyan hover:text-f2b-cyan transition-colors" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
            )}
            {contact.facebook && (
              <a href={contact.facebook} target="_blank" rel="noreferrer" className="p-2 border border-white/20 hover:border-f2b-cyan hover:text-f2b-cyan transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="f2b-container mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
        <p>© {new Date().getFullYear()} FACADES2build — Version de démonstration éditoriale.</p>
        <div className="flex gap-6">
          <Link to="/mentions-legales" className="hover:text-white/80">Mentions légales</Link>
          <Link to="/admin" className="hover:text-white/80" data-testid="footer-admin-link">Back-office</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
